import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { ConfigService } from '@fcom/core';
import { LanguageService } from '@fcom/ui-translate';

@Injectable()
export class CountryShopService {
  private isEnabled: boolean;

  constructor(
    private configService: ConfigService,
    private languageService: LanguageService
  ) {
    this.isEnabled = this.configService.cfg.enableCountryShops;
  }

  setIsEnabled(isEnabled: boolean): void {
    this.isEnabled = isEnabled;
  }

  getIsEnabled(): Observable<boolean> {
    return this.languageService.countryCode.pipe(map((countryCode) => countryCode === 'SE' && this.isEnabled));
  }
}
